angular.module('Itao.IndicatorMap').factory('ColorSetService', function (mapConfig) {
  'use strict';

  /**
   * @param uid
   * @param name
   * @param colors
   * @constructor
   */
  function ColorSet(uid, name, colors) {
    this.uid = uid;
    this.name = name;
    this.colors = colors;
  }

  return {
    createColorSet: function (uid, name, colors) {
      return new ColorSet(uid, name, colors);
    }
  };
});
